import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Notification from '@websky/core/src/Notification/components/Notification';
import { InfoMessageTypeEnum } from '@websky/graphql';
import css from './DisabilitiesPassengerNotification.css';
var DisabilitiesPassengerNotification = function () {
    var t = useTranslation('Contacts').t;
    return (React.createElement(Notification, { status: InfoMessageTypeEnum.Promo, infoMessage: {
            text: t('If special arrangements are required for the disabled passenger, please fill request form or call the hotline at 8 800 234 4402.'),
            type: InfoMessageTypeEnum.Info,
            code: '1'
        }, type: "context", className: css.notification__wrapper, iconClassName: css.notification__icon, textClassName: css.notification__text }));
};
export default DisabilitiesPassengerNotification;
